import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { quoteFormSelector } from 'ctm-selectors';
import moment from 'moment';
import { convertStringCase } from 'ctm-components';
import { QuoteCard } from '../quote_card';
import { QuoteQuestionPlainItem } from '../quote_question_plain_item';

const _YoungerDriver = (props) => {
    const { youngerDriverGender, youngerDriverDob, youngerDriverLicenceAge, hasYoungerDriver } = props;
    return (
        <QuoteCard title="Younger driver" path="youngest_driver">
            {
                hasYoungerDriver
                    ? (
                        <>
                            <QuoteQuestionPlainItem title="Gender" content={convertStringCase(youngerDriverGender.toLowerCase(), 'title')} />
                            <QuoteQuestionPlainItem title="Date of birth" content={moment(youngerDriverDob).format('DD/MM/YYYY') || ''} />
                            <QuoteQuestionPlainItem title="Licence age" content={youngerDriverLicenceAge} />
                        </>
                    )
                    :                                            (
                        <QuoteQuestionPlainItem titleOnlyMode title="No younger driver listed" />
                    )
            }
        </QuoteCard>
    );
};

_YoungerDriver.propTypes = {
    youngerDriverGender: PropTypes.string,
    youngerDriverDob: PropTypes.string,
    youngerDriverLicenceAge: PropTypes.string,
    hasYoungerDriver: PropTypes.bool
};

const mapStateToProps = (state) => {
    return {
        youngerDriverGender: quoteFormSelector(state).getIn(['coverDetail', 'youngestDriver', 'gender']) || '',
        youngerDriverDob: quoteFormSelector(state).getIn(['coverDetail', 'youngestDriver', 'dob']) || '',
        youngerDriverLicenceAge: quoteFormSelector(state).getIn(['coverDetail', 'youngestDriver', 'licenceAge']) || '',
        hasYoungerDriver: quoteFormSelector(state).getIn(['coverDetail', 'hasYoungerDriver']) === 'Y' || false
    };
};

const YoungerDriver = connect(mapStateToProps)(_YoungerDriver);

export { YoungerDriver, _YoungerDriver };
